export const EMAIL_REGEX = '([a-zA-Z0-9]?(.)?)+[a-zA-Z0-9]+@[a-zA-Z0-9]+.[a-zA-Z]+';
export const IBAN_REGEX =
  '^([A-Z]{2}[ \\-]?[0-9]{2})(?=(?:[ \\-]?[A-Z0-9]){9,30}$)((?:[ \\-]?[A-Z0-9]{3,5}){2,7})([ \\-]?[A-Z0-9]{1,3})?$';
export const PHONE_REGEX =
  '^(?:(?:\\+|00)33[\\s.-]{0,3}(?:\\(0\\)[\\s.-]{0,3})?|0)[1-9](?:(?:[\\s.-]?\\d{2}){4}|\\d{2}(?:[\\s.-]?\\d{3}){2})$';
export const POSTAL_CODE_REGEX = '^(?:[0-8]\\d|9[0-8])\\d{3}$';
export const SIREN_REGEX = '(\\d{9}|\\d{3}[ ]\\d{3}[ ]\\d{3})';

// Companies

export const MAX_PICTURE_SIZE_TOTAL = 6000000;

// Service

export const serviceLevels = [
  { value: 'beginner', label: 'Débutant' },
  { value: 'intermediate', label: 'Intermédiaire' },
  { value: 'expert', label: 'Expert' },
  { value: 'all', label: 'Tout Niveau' },
];

export const serviceLevelsColor = {
  Débutant: 'success',
  Intermédiaire: 'warning',
  Expert: 'danger',
  'Tout Niveau': 'success',
};

export const serviceSlotType = [
  { label: 'Individuel', value: 'private' },
  { label: 'Collectif', value: 'public' },
  { label: 'Groupe', value: 'group' },
];

export const showActionType = {
  CONFLICT_SELECT: 'CONFLICT_SELECT',
  CONFLICT_TRANSFER: 'CONFLICT_TRANSFER',
  PREFERENCE_WARNING: 'PREFERENCE_WARNING',
  SELECT_ACTION: 'SELECT_ACTION',
  SELECT_ADDRESS: 'SELECT_ADDRESS',
  SHOULD_TRANSFER: 'SHOULD_TRANSFER',
};

export const actionType = {
  DELETE: 'delete',
  DEACTIVATE: 'deactivate',
};

export const currencies = {
  EUR: '€',
  USD: '$',
};

export const seasonsPrices = {
  low_season: 'Basse saison',
  peak_season: 'Haute saison',
};

// Addresses

export const streetIndexList = [
  { value: 'none', label: 'aucun' },
  { value: 'B', label: 'bis' },
  { value: 'T', label: 'ter' },
  { value: 'Q', label: 'quater' },
  { value: 'C', label: 'quinquies' },
];

export const streetTypeList = [
  { value: 'AIRE', label: 'Aire' },
  { value: 'ALL', label: 'Allée' },
  { value: 'AV', label: 'Avenue' },
  { value: 'BASE', label: 'Base' },
  { value: 'BD', label: 'Boulevard' },
  { value: 'CAMI', label: 'Cami' },
  { value: 'CAR', label: 'Carrefour' },
  { value: 'CHE', label: 'Chemin' },
  { value: 'CHEM', label: 'Cheminement' },
  { value: 'CHS', label: 'Chaussée' },
  { value: 'CITE', label: 'Cité' },
  { value: 'CLOS', label: 'Clos' },
  { value: 'COIN', label: 'Coin' },
  { value: 'COR', label: 'Corniche' },
  { value: 'COTE', label: 'Cote' },
  { value: 'COUR', label: 'Cour' },
  { value: 'CRS', label: 'Cours' },
  { value: 'DOM', label: 'Domaine' },
  { value: 'DSC', label: 'Descente' },
  { value: 'ECA', label: 'Ecart' },
  { value: 'ESP', label: 'Esplanade' },
  { value: 'FG', label: 'Faubourg' },
  { value: 'GARE', label: 'Gare' },
  { value: 'GR', label: 'Grande Rue' },
  { value: 'HAM', label: 'Hameau' },
  { value: 'HLE', label: 'Halle' },
  { value: 'ILOT', label: 'Ilôt' },
  { value: 'IMP', label: 'Impasse' },
  { value: 'LD', label: 'Lieu dit' },
  { value: 'LOT', label: 'Lotissement' },
  { value: 'MAR', label: 'Marché' },
  { value: 'MTE', label: 'Montée' },
  { value: 'PARC', label: 'Parc' },
  { value: 'PAS', label: 'Passage' },
  { value: 'PL', label: 'Place' },
  { value: 'PLAN', label: 'Plan' },
  { value: 'PLN', label: 'Plaine' },
  { value: 'PLT', label: 'Plateau' },
  { value: 'PONT', label: 'Pont' },
  { value: 'PORT', label: 'Port' },
  { value: 'PRO', label: 'Promenade' },
  { value: 'PRV', label: 'Parvis' },
  { value: 'QUA', label: 'Quartier' },
  { value: 'QUAI', label: 'Quai' },
  { value: 'RES', label: 'Résidence' },
  { value: 'RLE', label: 'Ruelle' },
  { value: 'ROC', label: 'Rocade' },
  { value: 'RPT', label: 'Rond Point' },
  { value: 'RTE', label: 'Route' },
  { value: 'RUE', label: 'Rue' },
  { value: 'SEN', label: 'Sente-Sentier' },
  { value: 'SQ', label: 'Square' },
  { value: 'TOUR', label: 'Tour' },
  { value: 'TPL', label: 'Terre-plein' },
  { value: 'TRA', label: 'Traverse' },
  { value: 'VLA', label: 'Villa' },
  { value: 'VLGE', label: 'Village' },
  { value: 'VOIE', label: 'Voie' },
  { value: 'ZA', label: 'Zone artisanale' },
  { value: 'ZAC', label: "Zone d'aménagement concerté" },
  { value: 'ZAD', label: "Zone d'aménagement différé" },
  { value: 'ZI', label: 'Zone industrielle' },
  { value: 'ZONE', label: 'Zone' },
];

// TOAST messages
export const toastMessages = {
  error: {
    ACTIVITY_CANNOT_ENABLE: "Veuillez d'abord enregistrer un moniteur et un lieu.",
    CONTRACT_CHECKED: 'Erreur lors de la validation des conditions générales',
    CREATE_ACTIVITY: "Erreur lors de la création de l'activité",
    CREATE_ADDRESS: "Erreur lors de la création de l'adresse",
    CREATE_AGENDA: "Erreur lors de la creation de l'agenda",
    CREATE_BOOKING: 'Erreur lors de la creation de la réservation',
    CREATE_COMPANY: "Erreur lors de la création de l'entreprise",
    CREATE_EMPLOYEE: 'Erreur lors de la création du moniteur',
    CREATE_HELP_REQUEST: 'Erreur lors de la création de la demande',
    CREATE_POST: 'Erreur lors de la création du post',
    DELETE_ACTIVITY: "Erreur lors de la suppression de l'activité",
    DELETE_ADDRESS: "Erreur lors de la suppression de l'adresse",
    DELETE_BOOKING: 'Erreur lors de la suppression de la réservation',
    DELETE_COMPANY: "Erreur lors de la suppression de l'entreprise",
    DELETE_DASHBOARD_NOTIFICATION: 'Erreur lors de la suppression de la notification',
    DELETE_EMPLOYEE: 'Erreur lors de la suppression du moniteur',
    DELETE_POST: 'Erreur lors de la suppression du post',
    EXPORT_BILL: "Erreur lors de l'exportation des factures",
    FACEBOOK_LOAD: 'Une erreur est survenue lors de la vérification de la connexion avec Facebook ...',
    FACEBOOK_LOGIN: 'Une erreur est survenue lors de la connexion à Facebook',
    FETCH_ACTIVITIES: 'Erreur lors du chargement des activités',
    FETCH_ADDRESSES: 'Erreur lors du chargement des adresses',
    FETCH_AGENDA_CONFIGURATION: 'Erreur lors du chargement de la configuration du moniteur',
    FETCH_AGENDA: "Erreur lors du chargement de l'agenda du moniteur",
    FETCH_CLIENTS: 'Erreur lors du chargement des clients',
    FETCH_COMPANIES: 'Erreur lors du chargement des entreprises',
    FETCH_COMPANY_DETAILS: "Erreur lors du chargement des détails de l'entreprise courante",
    FETCH_DASHBOARD: 'Erreur lors du chargement du tableau de bord',
    FETCH_DASHBOARD_NOTIFICATIONS: 'Erreur lors du chargement des notifications du tableau de bord',
    FETCH_EMPLOYEES: 'Erreur lors du chargement des moniteurs',
    FETCH_HELP_REQUESTS: 'Erreur lors du chargement des requêtes',
    FETCH_POSTS: 'Erreur lors du chargement des posts',
    FETCH_PROFILE_PICTURE: 'Erreur lors du chargement de la photo de profil',
    FETCH_PROVIDER: 'Erreur lors du chargement des données utilisateur',
    FETCH_NOTIFICATIONS: 'Erreur lors du chargement des paramètres de notification',
    FETCH_STEPS: "Erreur lors du chargement des étapes d'enregistrement",
    FILE_MAX_DATA: 'Vous dépassez la limite de données autorisée',
    FILE_MAX_NUMBER: 'Vous dépassez la limite de nombre de fichiers autorisée',
    POST_FILE_FORMAT: 'Format de fichier non autorisé',
    POST_FILE_SIZE: 'Fichier trop volumineux (8MB image / 100MB vidéo)',
    REGISTER_CONFIG: "Erreur lors de l'enregistrement de la configuration",
    SESSION_EXPIRED: 'Session expirée, veuillez vous reconnecter',
    SEND_INVITATION: "Une erreur est survenue lors de l'envoi des invitations",
    TOO_LONG_SESSION:
      'Impossible de modifier votre mot de passe car vous êtes connecté depuis trop longtemps.' +
      ' Veuillez vous reconnecter avant de faire la modification.',
    TRANSFER_AGENDA: "Une erreur est survenue lors du transfert de l'agenda",
    TRANSFER_ADDRESS: "Une erreur est survenue lors du transfert de l'adresse",
    RESOLVED_CONFLICTS: 'Une erreur est survenue lors de la résolution des conflits',
    UPDATE_ACTIVITY: "Erreur lors de la mise à jour de l'activité",
    UPDATE_ADDRESS: "Erreur lors de la mise à jour de l'adresse",
    UPDATE_BOOKING: 'Erreur lors de la mise à jour de la réservation',
    UPDATE_COMPANY: "Erreur lors de la mise à jour des données de l'entreprise",
    UPDATE_COMPANY_DETAILS: "Erreur lors de la mise à jour des détails de l'entreprise",
    UPDATE_COMPANY_DETAILS_PICTURE_SIZE_LIMIT: 'La taille totale des fichiers ne doit pas dépasser 6 Mo',
    UPDATE_DOCUMENT: 'Erreur lors de la mise à jour du document',
    UPDATE_EMPLOYEE: 'Erreur lors de la modification du moniteur',
    UPDATE_EMPLOYEE_ACTIVITY: "Erreur lors de l'assignation de l'activité au moniteur",
    UPDATE_EMPLOYEE_PROFILE_PICTURE: 'Erreur lors de la modification de la photo de profil du moniteur',
    UPDATE_NOTIFICATIONS: 'Erreur lors de la mise à jour des paramètres de notification',
    UPDATE_POST: 'Erreur lors de la mise à jour du post',
    UPDATE_PROFILE_PICTURE: 'Erreur lors de la mise à jour de la photo de profil',
    UPDATE_PROVIDER: 'Erreur lors de la mise à jour des données utilisateur',
    UPLOAD_PICTURE_SIZE_LIMIT: "La taille de l'image ne doit pas dépasser 6 Mo",
    VIDEO_DURATION: 'Durée de vidéo non autorisée (3 - 60 secondes)',
  },
  success: {
    CREATE_ACTIVITY: "L'activité a été créée avec succès",
    CREATE_ADDRESS: "L'adresse a été créée avec succès",
    CREATE_AGENDA: "L'agenda a été créé avec succès",
    CREATE_BOOKING: 'La réservation a été créée avec succès',
    CREATE_COMPANY: "L'entreprise a été créée avec succès",
    CREATE_EMPLOYEE: 'Le moniteur a été créé avec succès',
    CREATE_HELP_REQUEST: 'Votre demande a été créé avec succès',
    CREATE_POST: 'Le post a été créé avec succès',
    DELETE_ACTIVITY: "L'activité a été supprimée avec succès",
    DELETE_ADDRESS: "L'adresse a été supprimée avec succès",
    DELETE_BOOKING: 'La réservation a été supprimée avec succès',
    DELETE_COMPANY: "L'entreprise a été supprimée avec succès",
    DELETE_DASHBOARD_NOTIFICATION: 'La notification a été supprimée avec succès',
    DELETE_EMPLOYEE: 'Le moniteur a été supprimé avec succès',
    DELETE_POST: 'Le post a été supprimé avec succès',
    RESOLVED_CONFLICTS: 'Les conflits ont été résolus avec succès',
    SEND_INVITATION: 'Invitation(s) envoyée(s) avec succès !',
    TRANSFER_AGENDA: "L'agenda a été transféré avec succès",
    UPDATE_ACTIVITY: "L'activité a été modifiée avec succès",
    UPDATE_ADDRESS: "L'adresse a été modifiée avec succès",
    UPDATE_BOOKING: 'La réservation a été modifiée avec succès',
    UPDATE_COMPANY: "Les données de l'entreprise ont été mises à jour",
    UPDATE_COMPANY_DETAILS: "Les détails de l'entreprise on bien été mis à jour",
    UPDATE_DOCUMENT: 'Le document a bien été déposé',
    UPDATE_EMPLOYEE: 'Le moniteur a été modifié avec succès',
    UPDATE_EMPLOYEE_PROFILE_PICTURE: "L'image du moniteur a bien été mise à jour",
    UPDATE_NOTIFICATIONS: 'Les paramètres de notification ont été mis à jour',
    UPDATE_POST: 'Le post a été modifié avec succès',
    UPDATE_PROFILE_PICTURE: 'La photo de profil a été mise à jour',
    UPDATE_PROVIDER: 'Les données utilisateur ont été mises à jour',
  },
};

export const initialEmployeeState = {
  birthdate: '',
  city: '',
  country: 'France',
  email: '',
  first_name: '',
  gender: 'male',
  is_agenda_enabled: true,
  is_enabled: true,
  last_name: '',
  level: 'beginner',
  phone: '',
  profilePictureURL: null,
  role: 'MONITEUR',
};

export const initialAddressState = {
  address_name: '',
  city_name: '',
  enabled: true,
  street_index: '',
  street_number: '',
  title: '',
  zip_code: '',
};
